import { Middleware } from "openapi-fetch";
import i18n from "../../i18n";
import { TOKEN_INFO_SESSION_STORAGE_KEY } from "../../constants";
import { getVariantValue } from "../variantTunnel";
import { ApiError } from "./ApiError";

// 他のミドルウェアでエラーにしなかった非2xxレスポンスを ApiError として投げる。
// onResponse はボディ解析前に呼ばれるため、ここでボディを読んで ApiError に持たせる
export const apiErrorMiddleware: Middleware = {
  async onResponse({ request, response }) {
    if (response.ok) return;
    const text = await response.clone().text();
    let body: unknown = text;
    try {
      body = JSON.parse(text);
    } catch {
      // JSONでなければテキストのまま
    }
    throw new ApiError(response, request.method.toLowerCase(), body);
  },
};

// WAFのブロック時にカスタムレスポンスへ付与されるヘッダー
const WAFBLOCK_HEADER = "X-Blocked-By-Waf";

// alert を出して読み込み直しを始めたら、呼び出し側には結果を返さない。
// 失敗を返すと、読み込み直しが終わるまでの間に呼び出し側のエラー表示（帯・トースト・エラー画面）が出るので、
// ページごと消えるまで終わらない Promise を返し、どの呼び出し側もエラーを受け取らないようにする
function waitForReload(): Promise<never> {
  return new Promise<never>(() => {});
}

// WAFのメンテナンスブロック時にカスタムレスポンスへ付与されるヘッダー
const MAINTENANCE_MODE_HEADER = "X-Maintenance-Mode";

export const wafMiddleware: Middleware = {
  onResponse({ response }) {
    const { status, headers } = response;

    if (status == 503 && headers.get(MAINTENANCE_MODE_HEADER) === "True") {
      window.alert(i18n.t("Error.waf.maintenance"));
      window.location.reload();
      return waitForReload();
    }

    if (status == 403 && headers.get(WAFBLOCK_HEADER) === "True") {
      window.alert(i18n.t("Error.waf.blocked"));
      window.location.reload();
      return waitForReload();
    }
  },
};

export const authMiddleware: Middleware = {
  onRequest({ request }) {
    if (request.headers.has("Authorization")) return;
    const tokenInfoStr = sessionStorage.getItem(TOKEN_INFO_SESSION_STORAGE_KEY);
    const tokenInfo = JSON.parse(tokenInfoStr || "null");
    if (tokenInfo) {
      request.headers.set("Authorization", `Bearer ${tokenInfo.access_token}`);
    }
  },
};

export const variantTunnelMiddleware: Middleware = {
  onRequest({ request }) {
    const variantValue = getVariantValue();
    if (variantValue === null) return;
    request.headers.set("X-Backend-Variant", variantValue);
  },
};
